import React, { useState, useEffect } from "react";
import { FileAndUploadButton } from "./FileAndUploadButton";

const FileUpload = ({
    saveOutputCallback,
    configurations,
    inputData,
    componentDataFromInit,
    callApi
}) =>
{
    const [file, setFile] = useState(null);
    const [fileUrl, setFileUrl] = useState("");
    const [preview, setPreview] = useState("");
    const [error, setError] = useState("")
    const [uploaded, setUploaded] = useState(false);

    useEffect(
        () => {
            if (!file) {
                setPreview(undefined);
                return;
            }

            const objectUrl = URL.createObjectURL(file);
            setPreview(objectUrl);

            return () => URL.revokeObjectURL(objectUrl);
        },
        [file]
    );

    const uploadFile = (e) =>
    {
        e.preventDefault();

        callApi("addToIpfs", file)
            .then(response => response.json())
            .then(added => {
                const url = `${configurations.fileURL}/${added.path}`;
                //The name must match the output name from component-info.json:
                saveOutputCallback({"fileUrl" : url});
                setFileUrl(url);
                setUploaded(true);
            })
            .catch(error => {
                console.error("Error adding file to IPFS:", error);
                setError(`Error uploading the file: ${error}`);
            });
    };

    const preUpload = (e) => e.target.value !== "" ?
        setFile(e.target.files[0]) : setFile(null);

    const renderFileUploadGroup = () =>
        <li className="list-group-item">
            <div className="row align-items-center justify-content-between">
                <div className="form-group col-6">
                    <label className="form-label">Upload file</label>
                    <input
                        className="form-control"
                        type="file" id="formFile"
                        onChange={ preUpload }
                        required
                    />
                    <FileAndUploadButton
                        file={ file }
                        fileUrl={ fileUrl }
                        uploaded={ uploaded }
                    />
                    { error }
                </div>
                <div className="col-auto align-self-stretch border text-muted">
                    {
                        preview ?
                            <img className="img-fluid" src={ preview }/> :
                            "You'll be able to preview your image here."
                    }
                </div>
            </div>
        </li>;

    return (
        <div className="container">
            <form onSubmit={ uploadFile }>
                <ul className="list-group list-group-flush">
                    { renderFileUploadGroup() }
                </ul>
            </form>
        </div>
    );
};

export default FileUpload;
